import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../pipes/translate.pipe';

@Component({
  selector: 'app-defect-agenda-dialog',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div class="defect-agenda-dialog-backdrop" (click)="onCancel()">
      <div class="defect-agenda-dialog" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h4 class="modal-title">{{ 'defect_agenda_modal_title' | translate }}</h4>
        </div>
        <div class="modal-body">{{ 'defect_agenda_modal_msg' | translate }}</div>
        <div class="modal-footer">
          <button type="button" class="link-btn" (click)="onEnable()">{{ 'defect_agenda_modal_enable_btn' | translate }}</button>
          <button type="button" class="link-btn secondary" (click)="onCancel()">{{ 'defect_agenda_modal_cancel_btn' | translate }}</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .defect-agenda-dialog-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 4000;
      pointer-events: auto;
    }

    .defect-agenda-dialog {
      background: white;
      border-radius: 5px;
      min-width: 300px;
      max-width: 500px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
      pointer-events: auto;
    }

    .modal-header {
      padding: 15px 20px;
      border-bottom: 1px solid #ddd;

      .modal-title {
        margin: 0;
        font-size: 18px;
        font-weight: 500;
        color: #333;
      }
    }

    .modal-body {
      padding: 20px;
      color: #666;
      font-size: 14px;
      line-height: 1.5;
    }

    .modal-footer {
      padding: 15px 20px;
      border-top: 1px solid #ddd;
      display: flex;
      justify-content: flex-end;
      gap: 10px;

      .link-btn {
        border: none;
        color: var(--ci-emerald);
        background-color: var(--ci-electric);
        border-color: var(--ci-electric);
        padding: 8px 15px;
        min-width: 100px;
        font-size: 14px;
        border-radius: 5px;
        border-width: 1px;
        text-align: center;
        cursor: pointer;

        &:hover {
          background-color: var(--ci-emerald);
          color: var(--ci-electric);
        }

        &.secondary {
          background-color: #999;

          &:hover {
            background-color: #777;
          }
        }
      }
    }
  `]
})
export class DefectAgendaDialogComponent {
  @Output() enableAgenda = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onEnable(): void {
    this.enableAgenda.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
